export default __webpack_public_path__ + "img/d9c66a68bc47890ad9fc42cbde84e89c.mp4";